import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import { Jalur } from "@/types"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"

export interface JalurResponse {
  data: Jalur[]
}

const getListJalur = async () => {
  const response = await api.get("/master/jalur/index", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterJalurPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJalur"],
    queryFn: getListJalur,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
